import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ProjectTypeActionTypes } from "./project-type.actions";
import { ProjectTypeActions } from "./project-type.actions";
import { ProjectTypeService } from "@/core/services/project-type.service";
import { ProjectTypeApiModel } from "@/core/models/api/project-type-api-model.model";

@Injectable()
export class ProjectTypeEffects {
    actions$ = inject(Actions);
    projectTypeService = inject(ProjectTypeService);

    constructor(){

    }

    _loadProjectType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectTypeActions.loadProjectTypes),
            exhaustMap(() => {
                return this.projectTypeService.getAll().pipe(
                    map((response: any) => {
                        const projectTypes = response as ProjectTypeApiModel[];
                        return ProjectTypeActions.loadProjectTypeSuccess({ projectTypes });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of(ProjectTypeActions.loadProjectTypeFail({ error: error.message }));
                    })
                )
            })
        )
    })

    _addProjectType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectTypeActions.addProjectType),
            exhaustMap((action) => {
                return this.projectTypeService.add(action.projectType).pipe(
                    map((response: any) => {
                        const projectType = response as ProjectTypeApiModel;
                        return ProjectTypeActions.addProjectTypeSuccess({ projectType });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _updateProjectType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectTypeActions.updateProjectType),
            exhaustMap((action) => {
                return this.projectTypeService.update(action.projectType).pipe(
                    map((response: any) => {
                        const projectType = response as ProjectTypeApiModel;
                        return ProjectTypeActions.updateProjectType({ projectType });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _deleteProjectType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ProjectTypeActions.deleteProjectType),
            exhaustMap((action) => {
                return this.projectTypeService.delete(action.projectTypeId).pipe(
                    map((response: any) => {
                        return ProjectTypeActions.deleteProjectType({ projectTypeId: action.projectTypeId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}